import axios from 'axios';
import { updateUrlGetParams } from '@/helpers/url';
import WebApi from '../WebApi';
class SitesApi extends WebApi {
    async getSites(code) {
        const params = {
            kind: `branch`,
            post_code: code,
        };
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/sites`, params));
        return data.sites;
    }
    ;
    async getSite(id) {
        const { data } = await axios.get(`${this.urlPrefix}/sites/${id}`);
        return data;
    }
    async deleteSite(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/sites/${id}`);
        return data;
    }
    async getHub(id) {
        const { data } = await axios.get(`${this.urlPrefix}/hubs/${id}`);
        return data;
    }
    async activateHub(id) {
        const { data } = await axios.put(`${this.urlPrefix}/hubs/${id}/activate_hub`);
        return data;
    }
    async activateBranch(id) {
        const { data } = await axios.put(`${this.urlPrefix}/sites/${id}/activate_branch`);
        return data;
    }
    async getSitesHubs(payload) {
        const sort = payload.sort_by_count ? `&sort_by_count=${payload.sort_by_count}` : '';
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sort}`;
        const { data } = await axios.get(`${this.urlPrefix}/hubs${urlParams}`);
        return data;
    }
    async createHub(hub) {
        const { data } = await axios.post(`${this.urlPrefix}/hubs`, { hub });
        return data;
    }
    async updateHub(hub, id) {
        const { data } = await axios.put(`${this.urlPrefix}/hubs/${id}`, { hub });
        return data;
    }
    async deleteHub(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/hubs/${id}`);
        return data;
    }
    async createSite(site) {
        const { data } = await axios.post(`${this.urlPrefix}/sites`, { site });
        return data;
    }
    async updateSite(site, id) {
        const { data } = await axios.put(`${this.urlPrefix}/sites/${id}`, { site });
        return data;
    }
    async getBranchesByPostCode(post_code, rooms, payload, branch_external_id = null, kind = 'branch', isByOrder = false, location = null) {
        const country_iso = payload.country_iso;
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/sites${isByOrder ? '/order' : ''}${urlParams}`, {
            post_code,
            kind,
            locations: true,
            ...(rooms && { rooms }),
            ...(branch_external_id && { branch_external_id }),
            ...(country_iso && { country_iso }),
            ...(location && isByOrder && { location }),
        }));
        return data;
    }
    async getServicePointsByPostCode(post_code, payload) {
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}`;
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/service_points${urlParams}`, {
            post_code,
        }));
        return data;
    }
    // eslint-disable-next-line max-len
    async getBranchesByPostCodeWithDistance({ kind, origin, post_code, current_page, per_page }) {
        const urlParams = `?pagination[per_page]=${per_page}&pagination[page]=${current_page}`;
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/sites/order${urlParams}`, {
            kind,
            ...(origin && { origin }),
            post_code,
        }));
        return data;
    }
    async getSiteAvatars(site, payload) {
        const sort = payload.sort_by_count ? `&sort_by_count=${payload.sort_by_count}` : '';
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sort}`;
        const { data } = await axios.get(`${this.urlPrefix}/sites?kind=${site}&avatars=true${urlParams}`);
        return data;
    }
    async getSitesBySearch(payload, searchValue, kind) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `&pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const { data } = await axios.get(`${this.urlPrefix}/sites?kind=${kind}&search=${searchValue}${urlParams}`);
        return data;
    }
    async getHubReassignments(payload) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/hub_reassignments`, {
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
        }));
        return data;
    }
    async getHubsBySearch(payload, searchValue) {
        const sortBy = payload.sort ? `&sort=${payload.sort}` : '';
        const urlParams = `?pagination[per_page]=${payload.per_page}&pagination[page]=${payload.current_page}${sortBy}`;
        const search = searchValue ? `&search=${searchValue}` : '';
        const { data } = await axios.get(`${this.urlPrefix}/hubs${urlParams}${search}`);
        return data;
    }
    async getServicePointsBySearch(payload, searchValue) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/service_points`, {
            'pagination[per_page]': payload.per_page,
            'pagination[page]': payload.current_page,
            ...(payload.sort_by_count && { sort_by_count: payload.sort_by_count }),
            ...(searchValue && { search: searchValue }),
        }));
        return data;
    }
    async getServicePoint(id) {
        const { data } = await axios.get(`${this.urlPrefix}/service_points/${id}`);
        return data;
    }
    async createServicePoint(service_point) {
        const { data } = await axios.post(`${this.urlPrefix}/service_points`, { service_point });
        return data;
    }
    async updateServicePoint(service_point, id) {
        const { data } = await axios.put(`${this.urlPrefix}/service_points/${id}`, { service_point });
        return data;
    }
    async deleteServicePoint(id) {
        const { data } = await axios.delete(`${this.urlPrefix}/service_points/${id}`);
        return data;
    }
    async getServicePointSchedulesData(id) {
        const { data } = await axios.get(`${this.urlPrefix}/service_point_working_schedules/${id}`);
        return data;
    }
    async updateServicePointSchedulesData(payload, currentData, id) {
        const { data } = await axios.put(`${this.urlPrefix}/service_point_working_schedules/${id}`, {
            'working_schedule': payload,
        });
        return data;
    }
}
const sitesApi = new SitesApi();
export { sitesApi as SitesApi, };
